// Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.

// This Amplify config is used only for local development.
// TODO(i/ERMINE-90): Delete me once ErmineService is internationalized and localized.

import { getCognitoBypassUrlOpener } from "../helpers";

export const LOCALHOST_AMPLIFY_CONFIG: {
  aws_user_pools_id: string;
  aws_cognito_identity_pool_id: string;
  aws_cognito_region: string;
  oauth: {
    responseType: string;
    redirectSignIn: string;
    domain: string;
    scope: string[];
    redirectSignOut: string;
    urlOpener?: (url: string) => Promise<void>;
  };
  aws_user_pools_web_client_id: string;
} = {
  // The following is not generic. You need to update it with your own resource IDs.
  // Local Test: L24-L31 Use the default values or change to your own cognito info
  aws_cognito_identity_pool_id:
    "us-west-2:5f9ca96d-2ed1-4bba-89e0-d9342dde3ec0",
  aws_cognito_region: "us-west-2",
  aws_user_pools_id: "us-west-2_2g3wslDic",
  aws_user_pools_web_client_id: "61qc1uig8ecaina4cfgcs9hl47",
  oauth: {
    domain:
      "3a39714e-d47f-4e10-b3fe-b7074b93df9b.auth.us-west-2.amazoncognito.com",
    redirectSignIn: "https://localhost.workspaces-web.com/",
    redirectSignOut: "https://localhost.workspaces-web.com/",
    scope: [
      "openid",
      "profile",
      "phone",
      "email",
      "aws.cognito.signin.user.admin",
    ],
    responseType: "code",
    urlOpener: getCognitoBypassUrlOpener("AmazonSSO"),
  },
};
